export const APIURL = "https://api.arbourhealthcaregroup.co.uk/";
// export const APIURL = "https://testapi.arbourhealthcaregroup.co.uk/";
// export const APIURL = "http://localhost:8002/";

// Auth
export const UserLogin = "api/v1/admin/users/userLogin";
export const SendOtp = "api/v1/admin/users/sendOtp";
export const VerifyAndUpdatePassword = "api/v1/admin/users/verifyAndUpdatePassword";
export const UserLogout = "api/v1/admin/users/userLogout";

// User
export const GetUserList = "api/v1/admin/users/getUserList?start={0}&length={1}&search={2}&roleId={3}&sortField={4}&sortOrder={5}&startDate={6}&endDate={7}";
export const GetUserData = "api/v1/admin/users/getUserData/{0}";
export const CreateUser = "api/v1/admin/users/createUser";
export const UpdateUser = "api/v1/admin/users/updateUser";
export const DeleteUser = "api/v1/admin/users/deleteUser/{0}";

// Jobs
export const GetJobList = "api/v1/admin/job/getJobList?start={0}&length={1}&search={2}&roleId={3}&sortField={4}&sortOrder={5}";
export const GetJobData = "api/v1/admin/job/getJobData/{0}";
export const CreateJob = "api/v1/admin/job/createJob";
export const UpdateJob = "api/v1/admin/job/updateJob";
export const DeleteJob = "api/v1/admin/job/deleteJob/{0}";

//Forms
export const GetFormList = "api/v1/admin/forms/getFormsList";
export const GetAllForms = "api/v1/admin/forms/getAllForms?formType={0}";
export const DeleteForm = "api/v1/admin/forms/deleteForm/{0}";
export const GetFormData = "api/v1/admin/forms/getForm/{0}";
export const CreateForm = "api/v1/admin/forms/createForm";
export const UpdateForm = "api/v1/admin/forms/updateForm";
export const DownloadMergedForms = "api/v1/admin/forms/downloadMergedForms";

// Score/Assessment Forms
export const CreateScoreForm = "api/v1/admin/forms/createScoreForm";
export const UpdateScoreForm = "api/v1/admin/forms/updateScoreForm";
export const GetScoreFormData = "api/v1/admin/forms/getScoreForm/{0}";
export const DeleteScoreForm = "api/v1/admin/forms/deleteScoreForm/{0}";

// Form Document Upload
export const UploadFormDocument = "api/v1/admin/forms/uploadFormDocument";


// News & Blogs
export const GetNewsBlogList = "api/v1/admin/newsblog/getNewsBlogList?start={0}&length={1}&search={2}&roleId={3}&sortField={4}&sortOrder={5}&type={6}&startDate={7}&endDate={8}";
export const GetNewsBlogsData = "api/v1/admin/newsblog/getNewsBlogsData/{0}";
export const CreateNewsBlogs = "api/v1/admin/newsblog/createNewsBlogs";
export const UpdateNewsBlogs = "api/v1/admin/newsblog/updateNewsBlogs";
export const DeleteNewsBlogs = "api/v1/admin/newsblog/deleteNewsBlogs/{0}";

// Location
export const GetLocationList = "api/v1/admin/location/getLocationList?start={0}&length={1}&search={2}&roleId={3}&sortField={4}&sortOrder={5}";
export const GetLocationData = "api/v1/admin/location/getLocationData/{0}";
export const CreateLocation = "api/v1/admin/location/createLocation";
export const UpdateLocation = "api/v1/admin/location/updateLocation";
export const DeleteLocation = "api/v1/admin/location/deleteLocation/{0}";

// Policy
export const GetPolicyList = "api/v1/admin/policy/getPolicyList?start={0}&length={1}&search={2}&sortField={3}&sortOrder={4}";
export const PreviewPolicy = "api/v1/admin/policy/previewPolicy";
export const DownloadPolicy = "api/v1/admin/policy/downloadPolicy";
export const UpdatePolicyWebVisibility = "api/v1/admin/policy/updatePolicyVisibility";
// export const GetLocationData = "api/v1/admin/policy/getLocationData/{0}";
export const CreatePolicy = "api/v1/admin/policy/createPolicy";
export const UpdatePolicy = "api/v1/admin/policy/updatePolicy";
export const DeletePolicy = "api/v1/admin/policy/deletePolicy/{0}";

// Reports
export const GetSubscriberList = "api/v1/admin/reports/getSubscriberList?start={0}&length={1}&search={2}&roleId={3}&sortField={4}&sortOrder={5}&startDate={6}&endDate={7}";
export const GetContactUsList = "api/v1/admin/reports/getContactUsList?start={0}&length={1}&search={2}&sortField={3}&sortOrder={4}&startDate={5}&endDate={6}&formType={7}";
export const GetCVList = "api/v1/admin/reports/getCVList?start={0}&length={1}&search={2}&roleId={3}&sortField={4}&sortOrder={5}&startDate={6}&endDate={7}";
export const UserLogs = "api/v1/admin/users/userLogs?start={0}&length={1}&userId={2}&sortField={3}&sortOrder={4}&startDate={5}&endDate={6}";
export const PreviewCV = "api/v1/admin/forms/previewCV";
export const DownloadCV = "api/v1/admin/forms/downloadCV";
export const GetSubmittedFormPreview = "api/v1/admin/forms/getSubmittedFormPreview";
export const GetPreviewForApproval = "api/v1/admin/forms/getPreviewForApproval";
export const GetUploadedFiles = "api/v1/admin/forms/getUploadedFiles";
export const GetDynamicFormPreview = "api/v1/admin/forms/getDynamicFormPreview";
export const GetScoreFormPreview = "api/v1/admin/forms/getScoreFormPreview";
export const TimesheetDetails = "api/v1/admin/reports/getTimesheetDetails?start={0}&length={1}&search={2}&sortField={3}&sortOrder={4}&startDate={5}&endDate={6}";

export const SubmittedForms = "api/v1/admin/forms/getSubmittedForms?start={0}&length={1}&search={2}&formId={3}&sortField={4}&sortOrder={5}&startDate={6}&endDate={7}&formType={8}&timesheetExpense={9}&isFormApproved={10}";
export const GetSubmittedFormDetailedData = "api/v1/admin/forms/getSubmittedFormDetailedData";
export const SafeguardingForm = "api/v1/admin/reports/getSafeguardingList?start={0}&length={1}&search={2}&sortField={3}&sortOrder={4}&startDate={5}&endDate={6}";

export const UploadImage = "api/v1/admin/newsblog/uploadImage";

// Dashboard
export const GetDashboardData = "api/v1/admin/reports/getDashboardData?dateStart={0}&dateEnd={1}";
export const VerifyAuth = "api/v1/admin/users/verifyAuth";

// Form
export const ApproveForm = "api/v1/admin/forms/approveForm";

// Configuration - CPD Images
export const UploadTempImage = "api/v1/admin/configuration/uploadTempImage";
export const SaveCPDImages = "api/v1/admin/configuration/saveCPDImages";
export const GetCPDImages = "api/v1/admin/configuration/getCPDImages";
export const DeleteCPDImage = "api/v1/admin/configuration/deleteCPDImage";
export const UpdateCPDImage = "api/v1/admin/configuration/updateCPDImage";
export const UpdateImageOrder = "api/v1/admin/configuration/updateImageOrder";

// Configuration - Handbooks
export const UploadHandbook = "api/v1/admin/configuration/uploadHandbook";
export const GetHandbook = "api/v1/admin/configuration/getHandbook?type={0}";
export const DeleteHandbook = "api/v1/admin/configuration/deleteHandbook";

// EOM (Employee of the Month)
export const GetEOMNominations = "api/v1/admin/eom/getNominations?month={0}&start={1}&length={2}";
export const GetEOMStatus = "api/v1/admin/eom/getStatus";
export const UpdateEOMStatus = "api/v1/admin/eom/updateStatus";
export const DeleteEOMNomination = "api/v1/admin/eom/deleteNomination/{0}";
export const GetEOMAvailableMonths = "api/v1/admin/eom/getAvailableMonths";

// EOM Winners
export const SaveEOMWinner = "api/v1/admin/eomwinners/save";
export const GetEOMWinner = "api/v1/admin/eomwinners/get?month={0}";
export const GetEOMWinners = "api/v1/admin/eomwinners/getAll?month={0}";
export const DeleteEOMWinner = "api/v1/admin/eomwinners/delete/{0}";
export const GetEOMWinnerAvailableMonths = "api/v1/admin/eomwinners/getAvailableMonths";

// House Master
export const GetHouseList = "api/v1/admin/housemaster/getHouseList?start={0}&length={1}&search={2}&sortField={3}&sortOrder={4}";
export const GetHouseData = "api/v1/admin/housemaster/getHouseData/{0}";
export const CreateHouse = "api/v1/admin/housemaster/createHouse";
export const UpdateHouse = "api/v1/admin/housemaster/updateHouse";
export const DeleteHouse = "api/v1/admin/housemaster/deleteHouse/{0}";

// Visitor Logbook Reports
export const GetVisitorReports = "api/v1/admin/logbook/getReports?houseId={0}&startDate={1}&endDate={2}&start={3}&length={4}&search={5}&sortField={6}&sortOrder={7}";